import dayjs from 'dayjs';
import { useMsal } from '@azure/msal-react';
import { useAuth } from 'auth';
import { loginRequest } from 'config';
import { appInsights } from './applicationInsightsService';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { TokenClaims, TokenInfo } from 'auth/types';
import { decodeJwt } from 'jose';

export const useRefreshToken = () => {
  const { instance, accounts } = useMsal();
  const { setTokenInfo } = useAuth();

  const refreshTokenOnDemand = async () => {
    try {
      if (accounts.length === 0) {
        throw new Error('No Accounts found in Msal.');
      }
      const res = await instance.acquireTokenSilent({
        account: accounts[0],
        scopes: loginRequest.scopes,
      });

      const decoded = decodeJwt(res.accessToken) as TokenClaims;
      return {
        expiration: new Date(decoded.exp * 1000),
        accessToken: res.accessToken,
        groups: decoded.groups ?? [],
        roles: decoded.roles ?? [],
        authenticationMethod: decoded.mfaMethod,
      } as TokenInfo;
    } catch (error) {
      appInsights?.trackException(
        {
          exception: error,
          severityLevel: SeverityLevel.Error,
        },
        {
          componentStack: {
            module: 'B2C Msal',
          },
        }
      );
      localStorage.clear();
      setTokenInfo(null);
      instance.logoutRedirect();
      if (process.env.NODE_ENV === 'development') {
        console.log('Authentication Error ', error);
      }

      return null;
    }
  };

  return { refreshTokenOnDemand };
};

export const isTokenExpired = (accessToken: string) => {
  const decoded = decodeJwt(accessToken) as TokenClaims;
  if (!decoded?.exp) return false;
  return dayjs(decoded.exp * 1000).isBefore(new Date());
};
